import NotesIcon from '@listening/assets/icons/notes.svg?react';

import { NotesSkeleton } from '@/components/web-fe/design-v2/skeletons';
import { createFileRoute } from '@tanstack/react-router';
import { audioSummaryAtom } from '@listening/frontend/query/audio-detail';
import { notesAtom } from '@listening/frontend/query/notes';
import { AsyncResult } from 'effect/reactivity';
import { Loader } from 'raf-effect-atom';
import { awaitWithinSsrBudget } from '@/lib/ssr-budget';
import * as m from '@/paraglide/messages';
import { NotesV2 } from '@/components/web-fe/design-v2/notes-v2';
import { DashboardPage } from '@/components/web-fe/pages/dashboard/dashboard-page';

export const Route = createFileRoute('/app/_authenticated/_dashboard/notes')({
  component: NotesPage,
  pendingComponent: NotesSkeleton,
  pendingMs: 0,
  // Each document's row shows its audio's summary, which only the notes name,
  // so those reads start once the notes are in.
  loader: async ({ context: { atoms } }) => {
    const notes = atoms.prefetch(notesAtom);
    await awaitWithinSsrBudget(
      atoms.ensure(notesAtom).then((loaded) => {
        const audioIds = new Set(
          AsyncResult.getOrElse(Loader.result(loaded), () => []).map(
            (note) => note.audio_conversion_id,
          ),
        );
        return Promise.all(
          [...audioIds].map((audioId) =>
            atoms.ensure(audioSummaryAtom, audioId),
          ),
        );
      }),
    );
    return { notes };
  },
  context: () => ({
    title: m.common_notes(),
    icon: NotesIcon,
  }),
});

function NotesPage() {
  return (
    <DashboardPage>
      <NotesV2 {...Route.useLoaderData()} />
    </DashboardPage>
  );
}
